import i18n from '@/i18n'
import { useGeneralStore } from '@/stores/general'
import { removeFBSlash } from '@/core/helper-functions.js'
import { fallbackLocale, isSupportedLocale } from '@/locales/locales'

// redirect for dashboard page
export const dashboardRedirect = to => {
  const generalStore = useGeneralStore()
  return { name: 'dashboard', params: { language: generalStore.currentLocale } }
}

// redirect for :language page
export const langGuardLocal = to => {
  if (isSupportedLocale(removeFBSlash(to.path))) {
    return `/${removeFBSlash(to.path)}/dashboard`
  } else {
    const generalStore = useGeneralStore()
    return `/${generalStore.currentLocale}${to.path}`
  }
}

// global beforeEach routeGuard
export const langGuardGlobal = async (to, from, next) => {
  const locale = to.params.language

  if (isSupportedLocale(locale)) {
    if (i18n.global.locale.value !== locale) {
      i18n.global.locale.value = locale
      return next(to.fullPath)
    }

    return next()
  } else {
    return next({ ...to, params: { ...to.params, language: fallbackLocale } })
  }
}
